module.exports = __webpack_public_path__ + "static/img/sprite202309.a25bdbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/sprite202309.png
// module id = YsT4
// module chunks = 7